import Loader from '../../Loader/Loader';
import RenderElemet from './RenderElemet';
import RenderRow from './RenderRow';
const RenderElemets = ({ elements, itemsShiners, darkMode }) => {
    if (!elements?.length) return null;
    return elements?.map((el, index) => {
        if (el === 'loader') {
            return <Loader key={`RenderElemets_${index}`} />;
        }
        if (el?.row) {
            return <RenderRow key={`RenderElemets_${index}`} darkMode={darkMode} itemsShiners={itemsShiners} row={el} />;
        }
        if (el?.content) {
            return el?.content?.map((item, i) => {
                if (item?.row) {
                    return (
                        <RenderRow
                            darkMode={darkMode}
                            itemsShiners={itemsShiners}
                            row={item}
                            key={`RenderElemets_${index}_${i}`}
                        />
                    );
                }
                return (
                    <RenderElemet
                        darkMode={darkMode}
                        itemsShiners={itemsShiners}
                        element={item}
                        key={`RenderElemets_${index}_${i}`}
                    />
                );
            });
        }
        return <RenderElemet darkMode={darkMode} itemsShiners={itemsShiners} element={el} key={`RenderElemets_${index}`} />;
    });
};
export default RenderElemets;
